import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import AdminLogin from './AdminLogin';

const API = `${process.env.REACT_APP_API_URL}`;

// ✅ Export to Excel
const exportToExcel = (data, filename, columns) => {
  const rows = data.map(item => {
    const row = {};
    columns.forEach(col => { row[col.label] = item[col.key] || '—'; });
    return row;
  });
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Data');
  XLSX.writeFile(wb, filename);
};

// ✅ Copy to clipboard and open NMC portal
const verifyNMC = (nmcNumber) => {
  if (nmcNumber) {
    navigator.clipboard.writeText(nmcNumber).then(() => {
      alert('NMC Number ' + nmcNumber + ' copied to clipboard!\nPaste it in the search box on the NMC portal.');
    }).catch(() => {
      prompt('Copy this NMC Number and paste it on the NMC portal:', nmcNumber);
    });
  }
  window.open('https://www.nmc.org.in/information-desk/indian-medical-register/', '_blank');
};

// ✅ Export to Excel


// ✅ Verify NMC — copy to clipboard + open NMC portal


const MHJLogo = ({ size = 52 }) => (
  <svg width={size} height={size} viewBox="216 265 667 510" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="adminLogoGrad" gradientUnits="userSpaceOnUse" x1="216" y1="0" x2="883" y2="0">
        <stop offset="0%" stopColor="#0a3fe0" />
        <stop offset="30%" stopColor="#3a54da" />
        <stop offset="60%" stopColor="#a42ea3" />
        <stop offset="100%" stopColor="#e2368c" />
      </linearGradient>
    </defs>
    <path fill="url(#adminLogoGrad)" fillRule="evenodd"
      d="M 496.00,344.00 C 495.10,340.80 481.87,333.69 479.00,332.00 C 476.13,330.31 454.79,319.09 450.00,317.00 C 445.21,314.91 421.08,306.25 417.00,305.00 C 412.92,303.75 394.81,299.69 391.00,299.00 C 387.19,298.31 370.86,296.21 367.00,296.00 C 363.14,295.79 336.07,295.92 335.00,296.00 C 333.93,296.08 329.80,298.36 329.00,299.00 C 328.20,299.64 325.48,303.11 325.00,304.00 C 324.52,304.89 323.01,308.99 323.00,310.00 C 322.99,311.01 323.00,478.77 323.00,479.00 C 323.00,479.23 323.77,479.99 324.00,480.00 C 324.23,480.01 349.77,480.01 350.00,480.00 C 350.23,479.99 351.00,479.23 351.00,479.00 C 351.00,478.77 350.99,328.68 351.00,328.00 C 351.01,327.32 353.33,325.11 354.00,325.00 C 354.67,324.89 366.61,324.80 369.00,325.00 C 371.39,325.20 386.69,327.26 390.00,328.00 C 393.31,328.74 417.84,335.17 423.00,337.00 C 428.16,338.83 451.85,349.45 455.00,351.00 C 458.15,352.55 471.68,360.52 474.00,362.00 C 476.32,363.48 487.69,371.82 488.00,372.00 C 488.31,372.18 489.90,371.34 490.00,371.00 C 490.10,370.66 496.90,347.20 496.00,344.00 Z M 263.00,361.00 C 262.36,403.88 261.64,452.12 261.00,495.00 C 248.20,496.60 233.80,498.40 221.00,500.00 C 221.00,507.36 221.00,515.64 221.00,523.00 C 282.12,523.96 402.75,528.01 412.00,526.00 C 421.25,523.99 432.40,491.32 442.00,475.00 C 454.16,504.12 467.84,536.88 480.00,566.00 C 486.08,562.48 497.98,558.36 499.00,555.00 C 500.02,551.64 524.84,434.64 537.00,378.00 C 550.12,454.48 564.88,540.52 578.00,617.00 C 584.40,614.12 596.77,611.29 598.00,608.00 C 599.23,604.71 621.12,516.20 632.00,473.00 C 638.40,480.36 647.12,495.96 652.00,496.00 C 656.88,496.04 729.31,473.85 741.00,474.00 C 752.69,474.15 806.38,486.88 810.00,498.00 C 813.62,509.12 808.64,621.76 808.00,680.00 C 774.08,679.68 718.73,676.21 702.00,679.00 C 685.27,681.79 623.12,704.84 586.00,717.00 C 609.36,700.04 645.77,669.77 659.00,664.00 C 672.23,658.23 762.43,650.04 774.00,635.00 C 785.57,619.96 776.84,516.38 776.00,512.00 C 775.16,507.62 757.64,507.24 749.00,505.00 C 748.36,539.24 758.17,599.02 747.00,612.00 C 735.83,624.98 640.37,640.49 626.00,648.00 C 611.63,655.51 574.32,693.56 550.00,715.00 C 523.44,692.60 482.44,652.96 467.00,645.00 C 451.56,637.04 362.45,621.36 354.00,614.00 C 345.55,606.64 351.96,566.40 351.00,544.00 C 342.04,544.00 331.96,544.00 323.00,544.00 C 325.24,574.72 319.20,629.02 330.00,640.00 C 340.80,650.98 429.15,659.39 442.00,665.00 C 454.85,670.61 488.92,701.72 511.00,719.00 C 476.44,706.52 420.66,683.05 403.00,680.00 C 385.34,676.95 326.84,680.68 291.00,681.00 C 290.36,637.16 289.64,587.84 289.00,544.00 C 280.36,543.68 270.64,543.32 262.00,543.00 C 263.60,596.12 265.40,655.88 267.00,709.00 C 315.00,709.96 393.59,706.69 417.00,712.00 C 440.41,717.31 537.67,774.76 558.00,775.00 C 578.33,775.24 650.29,719.96 670.00,715.00 C 689.71,710.04 782.88,708.20 836.00,705.00 C 836.96,638.76 838.04,564.24 839.00,498.00 C 849.88,497.36 870.00,497.36 873.00,496.00 C 876.00,494.64 879.80,483.76 883.00,478.00 C 844.60,470.64 801.40,462.36 763.00,455.00 C 788.60,424.60 839.37,366.40 843.00,360.00 C 846.63,353.60 845.19,320.33 843.00,314.00 C 840.81,307.67 821.85,285.26 816.00,282.00 C 810.15,278.74 779.30,274.03 773.00,275.00 C 766.70,275.97 744.37,294.08 738.00,294.00 C 731.63,293.92 697.15,273.65 689.00,274.00 C 680.85,274.35 647.75,294.44 644.00,298.00 C 640.25,301.56 632.55,322.86 632.00,328.00 C 631.45,333.14 633.97,359.04 637.00,364.00 C 640.03,368.96 680.52,416.36 701.00,441.00 C 708.36,435.56 716.64,429.44 724.00,424.00 C 704.16,400.64 664.82,357.35 662.00,351.00 C 659.18,344.65 669.95,312.59 673.00,309.00 C 676.05,305.41 697.58,302.38 702.00,304.00 C 706.42,305.62 728.52,324.40 741.00,334.00 C 750.60,325.04 767.63,307.87 771.00,306.00 C 774.37,304.13 791.31,302.88 795.00,304.00 C 798.69,305.12 812.11,315.62 814.00,319.00 C 815.89,322.38 819.54,341.08 818.00,345.00 C 816.46,348.92 791.53,386.35 785.00,393.00 C 778.47,399.65 708.37,458.67 703.00,462.00 C 697.63,465.33 669.54,471.03 664.00,468.00 C 658.46,464.97 641.31,429.36 639.00,427.00 C 636.69,424.64 625.40,423.60 619.00,422.00 C 609.08,454.96 597.92,492.04 588.00,525.00 C 574.88,444.04 560.12,352.96 547.00,272.00 C 539.64,275.20 525.13,278.15 524.00,282.00 C 522.87,285.85 494.76,427.52 481.00,496.00 C 473.32,474.56 458.64,431.86 457.00,429.00 C 455.36,426.14 444.08,423.56 438.00,421.00 C 425.84,445.32 412.08,490.76 400.00,497.00 C 387.92,503.24 325.88,497.00 291.00,497.00 C 290.36,461.48 288.64,388.77 289.00,386.00 C 289.36,383.23 304.62,384.43 306.00,382.00 C 307.38,379.57 306.00,364.32 306.00,356.00 C 292.24,357.60 276.76,359.40 263.00,361.00 Z" />
  </svg>
);

// ═══ SHARED STYLES ═══
const C = {
  bg: '#f8fafc',
  sidebar: '#ffffff',
  border: '#e2e8f0',
  text: '#0f172a',
  textSub: '#64748b',
  blue: '#0a3fe0',
  purple: '#a42ea3',
  pink: '#e2368c',
  green: '#16a34a',
  amber: '#d97706',
  red: '#dc2626',
  lightBlue: '#eff6ff',
  lightPurple: '#faf5ff',
  lightGreen: '#f0fdf4',
  lightAmber: '#fffbeb',
  lightRed: '#fef2f2',
  white: '#ffffff',
  headerBg: '#ffffff',
};

const btn = (label, bg, color, border, onClick) => (
  <button onClick={onClick} style={{
    padding: '5px 12px', borderRadius: '6px', border: `1px solid ${border}`,
    background: bg, color, fontSize: '11px', fontWeight: 600, cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap'
  }}>{label}</button>
);

const StatusBadge = ({ status }) => {
  const map = {
    approved: { bg: '#dcfce7', color: '#166534', label: 'Approved' },
    active: { bg: '#dcfce7', color: '#166534', label: 'Active' },
    pending: { bg: '#fef3c7', color: '#92400e', label: 'Pending' },
    rejected: { bg: '#fee2e2', color: '#991b1b', label: 'Rejected' },
    inactive: { bg: '#f1f5f9', color: '#475569', label: 'Inactive' },
  };
  const s = map[status] || map.pending;
  return (
    <span style={{ background: s.bg, color: s.color, fontSize: '11px', fontWeight: 600, padding: '3px 10px', borderRadius: '20px', display: 'inline-block' }}>
      {s.label}
    </span>
  );
};

// ═══ SIDEBAR ═══
function Sidebar({ activeTab, setActiveTab, onLogout, pendingCount }) {
  const nav = [
    { id: 'dashboard', icon: 'dashboard', label: 'Dashboard' },
    { id: 'doctors', icon: 'medical_services', label: 'Doctors', badge: pendingCount.doctors },
    { id: 'providers', icon: 'local_hospital', label: 'Providers', badge: pendingCount.providers },
    { id: 'patients', icon: 'group', label: 'Patients' },
  ];
  return (
    <div style={{ width: '220px', minWidth: '220px', height: '100vh', background: C.white, borderRight: `1px solid ${C.border}`, display: 'flex', flexDirection: 'column', position: 'fixed', left: 0, top: 0, zIndex: 50 }}>
      {/* Logo */}
      <div style={{ padding: '20px 16px 16px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: '10px' }}>
        <MHJLogo size={40} />
        <div>
          <p style={{ color: C.text, fontSize: '13px', fontWeight: 700, margin: 0 }}>MyHealth Journal</p>
          <p style={{ color: C.textSub, fontSize: '10px', margin: 0 }}>Super Admin</p>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: '12px 8px' }}>
        {nav.map(item => {
          const active = activeTab === item.id;
          return (
            <button key={item.id} onClick={() => setActiveTab(item.id)} style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: '10px',
              padding: '10px 12px', borderRadius: '10px', border: 'none', marginBottom: '2px',
              background: active ? C.lightBlue : 'transparent',
              color: active ? C.blue : C.textSub,
              fontSize: '13px', fontWeight: active ? 600 : 400, cursor: 'pointer', textAlign: 'left',
            }}>
              <span className="material-symbols-outlined" style={{ fontSize: '18px', fontVariationSettings: active ? '"FILL" 1' : '"FILL" 0' }}>{item.icon}</span>
              <span style={{ flex: 1 }}>{item.label}</span>
              {item.badge > 0 && (
                <span style={{ background: C.amber, color: '#fff', fontSize: '10px', fontWeight: 700, borderRadius: '50%', width: '18px', height: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{item.badge}</span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Logout */}
      <div style={{ padding: '12px 8px', borderTop: `1px solid ${C.border}` }}>
        <button onClick={onLogout} style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px', borderRadius: '10px', border: 'none', background: 'transparent', color: C.red, fontSize: '13px', fontWeight: 500, cursor: 'pointer' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>logout</span>Sign out
        </button>
      </div>
    </div>
  );
}

// ═══ TOPBAR ═══
function TopBar({ activeTab, onRefresh, onLogout, pendingCount }) {
  const [showNotif, setShowNotif] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const titles = { dashboard: 'Dashboard', doctors: 'Doctors', providers: 'Providers', patients: 'Patients' };
  const total = pendingCount.doctors + pendingCount.providers;

  return (
    <div style={{ height: '60px', background: C.white, borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', flexShrink: 0, position: 'sticky', top: 0, zIndex: 40 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <h1 style={{ color: C.text, fontSize: '18px', fontWeight: 700, margin: 0 }}>{titles[activeTab]}</h1>
        <button onClick={onRefresh} style={{ background: 'none', border: 'none', cursor: 'pointer', color: C.textSub, padding: '4px', borderRadius: '6px' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>refresh</span>
        </button>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {/* Notification */}
        <div style={{ position: 'relative' }}>
          <button onClick={() => { setShowNotif(!showNotif); setShowMenu(false); }} style={{ width: '36px', height: '36px', borderRadius: '8px', border: `1px solid ${C.border}`, background: C.white, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative', color: C.textSub }}>
            <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>notifications</span>
            {total > 0 && <span style={{ position: 'absolute', top: '4px', right: '4px', width: '8px', height: '8px', background: C.red, borderRadius: '50%', border: '1.5px solid #fff' }} />}
          </button>
          {showNotif && (
            <div style={{ position: 'absolute', right: 0, top: '44px', width: '280px', background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', boxShadow: '0 8px 24px rgba(0,0,0,0.08)', zIndex: 100 }}>
              <div style={{ padding: '14px 16px', borderBottom: `1px solid ${C.border}` }}>
                <p style={{ color: C.text, fontSize: '13px', fontWeight: 600, margin: 0 }}>Notifications</p>
              </div>
              {total > 0 ? (
                <div style={{ padding: '12px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: C.lightAmber, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span className="material-symbols-outlined" style={{ fontSize: '18px', color: C.amber, fontVariationSettings: '"FILL" 1' }}>pending_actions</span>
                    </div>
                    <div>
                      <p style={{ color: C.text, fontSize: '13px', fontWeight: 500, margin: 0 }}>{total} pending approval{total > 1 ? 's' : ''}</p>
                      <p style={{ color: C.textSub, fontSize: '11px', margin: 0 }}>Doctors & providers waiting</p>
                    </div>
                  </div>
                </div>
              ) : (
                <div style={{ padding: '24px 16px', textAlign: 'center' }}>
                  <span className="material-symbols-outlined" style={{ fontSize: '32px', color: C.border, display: 'block', marginBottom: '8px' }}>notifications_off</span>
                  <p style={{ color: C.textSub, fontSize: '13px', margin: 0 }}>No new notifications</p>
                </div>
              )}
            </div>
          )}
        </div>
        {/* Avatar */}
        <div style={{ position: 'relative' }}>
          <button onClick={() => { setShowMenu(!showMenu); setShowNotif(false); }} style={{ width: '36px', height: '36px', borderRadius: '50%', border: 'none', background: 'linear-gradient(135deg,#0a3fe0,#e2368c)', color: '#fff', fontSize: '13px', fontWeight: 700, cursor: 'pointer' }}>A</button>
          {showMenu && (
            <div style={{ position: 'absolute', right: 0, top: '44px', width: '180px', background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', boxShadow: '0 8px 24px rgba(0,0,0,0.08)', zIndex: 100, overflow: 'hidden' }}>
              <div style={{ padding: '12px 16px', borderBottom: `1px solid ${C.border}` }}>
                <p style={{ color: C.text, fontSize: '13px', fontWeight: 600, margin: 0 }}>Super Admin</p>
                <p style={{ color: C.textSub, fontSize: '11px', margin: 0 }}>admin@myhealth.com</p>
              </div>
              <button onClick={onLogout} style={{ width: '100%', padding: '12px 16px', background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', color: C.red, fontSize: '13px', fontWeight: 500 }}>
                <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>logout</span>Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ═══ TABLE WRAPPER ═══
function TableWrap({ children }) {
  return (
    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', overflow: 'hidden' }}>
      {children}
    </div>
  );
}


function SearchBar({ value, onChange, placeholder }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: C.white, border: `1px solid ${C.border}`, borderRadius: '10px', padding: '10px 14px', marginBottom: '16px' }}>
      <span className="material-symbols-outlined" style={{ color: C.textSub, fontSize: '18px' }}>search</span>
      <input type="text" placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)}
        style={{ background: 'transparent', border: 'none', color: C.text, fontSize: '13px', outline: 'none', flex: 1 }} />
    </div>
  );
}

// ═══ DASHBOARD HOME ═══
function DashboardHome({ stats, doctors, providers, onApproveDoctor, onRejectDoctor, onApproveProvider, onRejectProvider }) {
  const pendingDoctors = doctors.filter(d => d.status === 'pending');
  const pendingProviders = providers.filter(p => p.status === 'pending');

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '14px', marginBottom: '24px' }}>
        {[
          { label: 'Total Patients', value: stats.totalPatients || 0, icon: 'group', color: C.blue, bg: C.lightBlue },
          { label: 'Total Doctors', value: stats.totalDoctors || 0, icon: 'medical_services', color: C.purple, bg: C.lightPurple },
          { label: 'Total Providers', value: stats.totalProviders || 0, icon: 'local_hospital', color: C.pink, bg: '#fff0f7' },
          { label: 'Pending Approvals', value: (stats.pendingDoctors || 0) + (stats.pendingProviders || 0), icon: 'pending_actions', color: C.amber, bg: C.lightAmber },
        ].map(s => (
          <div key={s.label} style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
              <p style={{ color: C.textSub, fontSize: '12px', margin: 0 }}>{s.label}</p>
              <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span className="material-symbols-outlined" style={{ color: s.color, fontSize: '18px', fontVariationSettings: '"FILL" 1' }}>{s.icon}</span>
              </div>
            </div>
            <p style={{ color: C.text, fontSize: '28px', fontWeight: 700, margin: 0 }}>{s.value}</p>
          </div>
        ))}
      </div>

      {/* Pending split */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '24px' }}>
        {/* Pending Doctors */}
        <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', overflow: 'hidden' }}>
          <div style={{ padding: '14px 16px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span className="material-symbols-outlined" style={{ color: C.blue, fontSize: '18px', fontVariationSettings: '"FILL" 1' }}>medical_services</span>
            <h3 style={{ color: C.text, fontSize: '14px', fontWeight: 600, margin: 0, flex: 1 }}>Pending Doctors</h3>
            {pendingDoctors.length > 0 && <span style={{ background: C.lightAmber, color: C.amber, fontSize: '11px', fontWeight: 600, padding: '2px 8px', borderRadius: '20px' }}>{pendingDoctors.length}</span>}
          </div>
          {pendingDoctors.length === 0 ? (
            <div style={{ padding: '24px', textAlign: 'center', color: C.textSub, fontSize: '13px' }}>No pending doctors</div>
          ) : pendingDoctors.map(d => (
            <div key={d.id} style={{ padding: '12px 16px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: C.lightBlue, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.blue, fontSize: '12px', fontWeight: 700, flexShrink: 0 }}>{d.name?.charAt(0)}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ color: C.text, fontSize: '13px', fontWeight: 500, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.name}</p>
                <p style={{ color: C.textSub, fontSize: '11px', margin: 0 }}>{d.specialization} · {d.phone}</p>
              </div>
              <div style={{ display: 'flex', gap: '6px' }}>
                {btn('✓', '#dcfce7', '#166534', '#bbf7d0', () => onApproveDoctor(d.id))}
                {btn('✗', '#fee2e2', '#991b1b', '#fecaca', () => onRejectDoctor(d.id))}
              </div>
            </div>
          ))}
        </div>

        {/* Pending Providers */}
        <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', overflow: 'hidden' }}>
          <div style={{ padding: '14px 16px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span className="material-symbols-outlined" style={{ color: C.purple, fontSize: '18px', fontVariationSettings: '"FILL" 1' }}>local_hospital</span>
            <h3 style={{ color: C.text, fontSize: '14px', fontWeight: 600, margin: 0, flex: 1 }}>Pending Providers</h3>
            {pendingProviders.length > 0 && <span style={{ background: C.lightAmber, color: C.amber, fontSize: '11px', fontWeight: 600, padding: '2px 8px', borderRadius: '20px' }}>{pendingProviders.length}</span>}
          </div>
          {pendingProviders.length === 0 ? (
            <div style={{ padding: '24px', textAlign: 'center', color: C.textSub, fontSize: '13px' }}>No pending providers</div>
          ) : pendingProviders.map(p => (
            <div key={p.id} style={{ padding: '12px 16px', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: C.lightPurple, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.purple, fontSize: '12px', fontWeight: 700, flexShrink: 0 }}>{p.name?.charAt(0)}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ color: C.text, fontSize: '13px', fontWeight: 500, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</p>
                <p style={{ color: C.textSub, fontSize: '11px', margin: 0 }}>{p.role} · {p.phone}</p>
              </div>
              <div style={{ display: 'flex', gap: '6px' }}>
                {btn('✓', '#dcfce7', '#166534', '#bbf7d0', () => onApproveProvider(p.id))}
                {btn('✗', '#fee2e2', '#991b1b', '#fecaca', () => onRejectProvider(p.id))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Overview */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
        {[
          { title: 'Doctors Overview', active: stats.activeDoctors || 0, pending: stats.pendingDoctors || 0, total: stats.totalDoctors || 0, color: C.blue },
          { title: 'Providers Overview', active: stats.activeProviders || 0, pending: stats.pendingProviders || 0, total: stats.totalProviders || 0, color: C.purple },
        ].map(card => (
          <div key={card.title} style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: '12px', padding: '16px' }}>
            <p style={{ color: C.text, fontSize: '14px', fontWeight: 600, margin: '0 0 12px' }}>{card.title}</p>
            {[{ label: 'Active', value: card.active, color: C.green }, { label: 'Pending', value: card.pending, color: C.amber }, { label: 'Total', value: card.total, color: card.color }].map(s => (
              <div key={s.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 0', borderBottom: `1px solid ${C.border}` }}>
                <span style={{ color: C.textSub, fontSize: '12px' }}>{s.label}</span>
                <span style={{ color: s.color, fontSize: '14px', fontWeight: 600 }}>{s.value}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

// ═══ DOCTORS TAB ═══
function DoctorsTab({ doctors, onApprove, onReject, onToggle }) {
  const [search, setSearch] = useState('');
  const filtered = doctors.filter(d => !search || d.name?.toLowerCase().includes(search.toLowerCase()) || d.phone?.includes(search) || d.nmcNumber?.includes(search));
  const cols = '1.8fr 1.2fr 1.4fr 1.2fr 1fr 0.8fr 1.6fr';

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
      {/* Export Button */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
        <button onClick={() => exportToExcel(filtered, 'Doctors.xlsx', [
          { label: 'Name', key: 'name' }, { label: 'Phone', key: 'phone' },
          { label: 'Specialization', key: 'specialization' }, { label: 'Email', key: 'email' },
          { label: 'NMC Number', key: 'nmcNumber' }, { label: 'Status', key: 'status' },
        ])} style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '9px 16px', borderRadius: '8px', border: '1px solid #bbf7d0', background: '#dcfce7', color: '#166534', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>download</span>Export to Excel
        </button>
      </div>
      

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', gap: '12px' }}>
        <div style={{ flex: 1 }}>
          <SearchBar value={search} onChange={setSearch} placeholder="Search by name, phone or NMC number..." />
        </div>
        <button onClick={() => exportToExcel(filtered, 'Doctors', [
          { label: 'Name', key: 'name' },
          { label: 'Phone', key: 'phone' },
          { label: 'Specialization', key: 'specialization' },
          { label: 'Email', key: 'email' },
          { label: 'NMC Number', key: 'nmcNumber' },
          { label: 'Status', key: 'status' },
        ])} style={{ padding: '10px 18px', borderRadius: '8px', border: `1px solid ${C.border}`, background: C.white, color: C.green, fontSize: '12px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
          <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>download</span>Export Excel
        </button>
      </div>

      <TableWrap>
        {/* Header */}
        <div style={{ display: 'grid', gridTemplateColumns: cols, padding: '10px 16px', background: '#f8fafc', borderBottom: `1px solid ${C.border}` }}>
          {['Name', 'Phone', 'Specialization', 'Gmail', 'NMC Number', 'Status', 'Actions'].map(h => (
            <span key={h} style={{ color: C.textSub, fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</span>
          ))}
        </div>
        {filtered.map(d => (
          <div key={d.id} style={{ display: 'grid', gridTemplateColumns: cols, padding: '12px 16px', borderBottom: `1px solid ${C.border}`, alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: C.lightBlue, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.blue, fontSize: '11px', fontWeight: 700, flexShrink: 0 }}>{d.name?.charAt(0)}</div>
              <span style={{ color: C.text, fontSize: '13px', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.name}</span>
            </div>
            <span style={{ color: C.textSub, fontSize: '12px' }}>{d.phone}</span>
            <span style={{ color: C.textSub, fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.specialization || '—'}</span>
            <span style={{ color: C.textSub, fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{d.email || '—'}</span>
            <span style={{ color: C.textSub, fontSize: '12px', fontFamily: 'monospace' }}>{d.nmcNumber || '—'}</span>
            <StatusBadge status={d.status} />
            <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
              {d.certificatePath && btn('View Doc', C.lightBlue, C.blue, '#bfdbfe', () => window.open(`${process.env.REACT_APP_API_URL}/${d.certificatePath.replace(/\\/g, '/')}`, '_blank'))}
              {btn('Verify NMC', '#faf5ff', C.purple, '#e9d5ff', () => verifyNMC(d.nmcNumber))}
              {d.status === 'pending' && <>
                {btn('Approve', '#dcfce7', '#166534', '#bbf7d0', () => onApprove(d.id))}
                {btn('Reject', '#fee2e2', '#991b1b', '#fecaca', () => onReject(d.id))}
              </>}
              {(d.status === 'approved' || d.status === 'inactive') && btn(d.status === 'inactive' ? 'Activate' : 'Deactivate', '#f1f5f9', C.textSub, C.border, () => onToggle(d.id))}
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p style={{ textAlign: 'center', color: C.textSub, padding: '32px', margin: 0 }}>No doctors found</p>}
      </TableWrap>
    </div>
  );
}

// ═══ PROVIDERS TAB ═══
function ProvidersTab({ providers, onApprove, onReject, onToggle }) {
  const [search, setSearch] = useState('');
  const filtered = providers.filter(p => !search || p.name?.toLowerCase().includes(search.toLowerCase()) || p.phone?.includes(search));
  const cols = '1.8fr 1.2fr 1.2fr 1.2fr 1.2fr 1fr 1.6fr';

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', gap: '12px' }}>
        <div style={{ flex: 1 }}>
          <SearchBar value={search} onChange={setSearch} placeholder="Search by name or phone..." />
        </div>
        <button onClick={() => exportToExcel(filtered, 'Providers', [
          { label: 'Name', key: 'name' },
          { label: 'Phone', key: 'phone' },
          { label: 'Type', key: 'role' },
          { label: 'Registration Number', key: 'registrationNumber' },
          { label: 'Email', key: 'email' },
          { label: 'Status', key: 'status' },
        ])} style={{ padding: '10px 18px', borderRadius: '8px', border: `1px solid ${C.border}`, background: C.white, color: C.green, fontSize: '12px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
          <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>download</span>Export Excel
        </button>
      </div>
      <TableWrap>
        <div style={{ display: 'grid', gridTemplateColumns: cols, padding: '10px 16px', background: '#f8fafc', borderBottom: `1px solid ${C.border}` }}>
          {['Name', 'Phone', 'Type', 'Reg. Number', 'Gmail', 'Status', 'Actions'].map(h => (
            <span key={h} style={{ color: C.textSub, fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</span>
          ))}
        </div>
        {filtered.map(p => (
          <div key={p.id} style={{ display: 'grid', gridTemplateColumns: cols, padding: '12px 16px', borderBottom: `1px solid ${C.border}`, alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: C.lightPurple, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.purple, fontSize: '11px', fontWeight: 700, flexShrink: 0 }}>{p.name?.charAt(0)}</div>
              <span style={{ color: C.text, fontSize: '13px', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.name}</span>
            </div>
            <span style={{ color: C.textSub, fontSize: '12px' }}>{p.phone}</span>
            <span style={{ color: C.textSub, fontSize: '12px' }}>{p.role || '—'}</span>
            <span style={{ color: C.textSub, fontSize: '12px', fontFamily: 'monospace' }}>{p.registrationNumber || '—'}</span>
            <span style={{ color: C.textSub, fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.email || '—'}</span>
            <StatusBadge status={p.status} />
            <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
              {p.documentPath && btn('View Doc', C.lightPurple, C.purple, '#e9d5ff', () => window.open(`${process.env.REACT_APP_API_URL}/${p.documentPath.replace(/\\/g, '/')}`, '_blank'))}
              {p.status === 'pending' && <>
                {btn('Approve', '#dcfce7', '#166534', '#bbf7d0', () => onApprove(p.id))}
                {btn('Reject', '#fee2e2', '#991b1b', '#fecaca', () => onReject(p.id))}
              </>}
              {(p.status === 'approved' || p.status === 'inactive') && btn(p.status === 'inactive' ? 'Activate' : 'Deactivate', '#f1f5f9', C.textSub, C.border, () => onToggle(p.id))}
            </div>
          </div>
        ))}
        {filtered.length === 0 && <p style={{ textAlign: 'center', color: C.textSub, padding: '32px', margin: 0 }}>No providers found</p>}
      </TableWrap>
    </div>
  );
}

// ═══ PATIENTS TAB ═══
function PatientsTab({ patients }) {
  const [search, setSearch] = useState('');
  const filtered = patients.filter(p => !search || p.name?.toLowerCase().includes(search.toLowerCase()) || p.phone?.includes(search) || p.patientUid?.toLowerCase().includes(search.toLowerCase()));
  const cols = '1.8fr 1.2fr 1.5fr 1.5fr 1.2fr';

  return (
    <div style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px', gap: '12px' }}>
        <div style={{ flex: 1 }}>
          <SearchBar value={search} onChange={setSearch} placeholder="Search by name, phone or patient ID..." />
        </div>
        <button onClick={() => exportToExcel(filtered, 'Patients', [
          { label: 'Name', key: 'name' },
          { label: 'Phone', key: 'phone' },
          { label: 'Patient ID', key: 'patientUid' },
          { label: 'Email', key: 'email' },
          { label: 'Aadhaar Last 4', key: 'aadhaarLast4' },
        ])} style={{ padding: '10px 18px', borderRadius: '8px', border: `1px solid ${C.border}`, background: C.white, color: C.green, fontSize: '12px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
          <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>download</span>Export Excel
        </button>
      </div>
      <TableWrap>
        <div style={{ display: 'grid', gridTemplateColumns: cols, padding: '10px 16px', background: '#f8fafc', borderBottom: `1px solid ${C.border}` }}>
          {['Name', 'Phone', 'Patient ID', 'Gmail', 'Aadhaar'].map(h => (
            <span key={h} style={{ color: C.textSub, fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{h}</span>
          ))}
        </div>
        {filtered.map(p => (
          <div key={p.id} style={{ display: 'grid', gridTemplateColumns: cols, padding: '12px 16px', borderBottom: `1px solid ${C.border}`, alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: C.lightGreen, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.green, fontSize: '11px', fontWeight: 700, flexShrink: 0 }}>{p.name?.charAt(0)}</div>
              <span style={{ color: C.text, fontSize: '13px', fontWeight: 500 }}>{p.name}</span>
            </div>
            <span style={{ color: C.textSub, fontSize: '12px' }}>{p.phone}</span>
            <span style={{ color: C.textSub, fontSize: '12px', fontFamily: 'monospace' }}>{p.patientUid}</span>
            <span style={{ color: C.textSub, fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.email || '—'}</span>
            <span style={{ color: C.textSub, fontSize: '12px', fontFamily: 'monospace' }}>{p.aadhaarLast4 ? `XXXX-XXXX-${p.aadhaarLast4}` : '—'}</span>
          </div>
        ))}
        {filtered.length === 0 && <p style={{ textAlign: 'center', color: C.textSub, padding: '32px', margin: 0 }}>No patients found</p>}
      </TableWrap>
    </div>
  );
}

// ═══ MAIN APP ═══
function AdminApp({ onLogout }) {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [stats, setStats] = useState({});
  const [doctors, setDoctors] = useState([]);
  const [providers, setProviders] = useState([]);
  const [patients, setPatients] = useState([]);

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    try {
      const [sRes, dRes, pRes, ptRes] = await Promise.all([
        fetch(`${API}/api/Admin/stats`),
        fetch(`${API}/api/Admin/doctors`),
        fetch(`${API}/api/Admin/providers`),
        fetch(`${API}/api/Admin/patients`),
      ]);
      if (sRes.ok) setStats(await sRes.json());
      if (dRes.ok) setDoctors(await dRes.json());
      if (pRes.ok) setProviders(await pRes.json());
      if (ptRes.ok) setPatients(await ptRes.json());
    } catch { }
  };

  const approveDoctor = async (id) => { await fetch(`${API}/api/Admin/doctors/${id}/approve`, { method: 'PATCH' }); fetchAll(); };
  const rejectDoctor = async (id) => { await fetch(`${API}/api/Admin/doctors/${id}/reject`, { method: 'PATCH' }); fetchAll(); };
  const toggleDoctor = async (id) => { await fetch(`${API}/api/Admin/doctors/${id}/toggle`, { method: 'PATCH' }); fetchAll(); };
  const approveProvider = async (id) => { await fetch(`${API}/api/Admin/providers/${id}/approve`, { method: 'PATCH' }); fetchAll(); };
  const rejectProvider = async (id) => { await fetch(`${API}/api/Admin/providers/${id}/reject`, { method: 'PATCH' }); fetchAll(); };
  const toggleProvider = async (id) => { await fetch(`${API}/api/Admin/providers/${id}/toggle`, { method: 'PATCH' }); fetchAll(); };

  const pendingCount = {
    doctors: doctors.filter(d => d.status === 'pending').length,
    providers: providers.filter(p => p.status === 'pending').length,
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, display: 'flex', width: '100vw', height: '100vh', background: C.bg, fontFamily: 'Inter, sans-serif', overflow: 'hidden', zIndex: 9999 }}>
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} onLogout={onLogout} pendingCount={pendingCount} />
      <div style={{ marginLeft: '220px', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
        <TopBar activeTab={activeTab} onRefresh={fetchAll} onLogout={onLogout} pendingCount={pendingCount} />
        {activeTab === 'dashboard' && <DashboardHome stats={stats} doctors={doctors} providers={providers} onApproveDoctor={approveDoctor} onRejectDoctor={rejectDoctor} onApproveProvider={approveProvider} onRejectProvider={rejectProvider} />}
        {activeTab === 'doctors' && <DoctorsTab doctors={doctors} onApprove={approveDoctor} onReject={rejectDoctor} onToggle={toggleDoctor} />}
        {activeTab === 'providers' && <ProvidersTab providers={providers} onApprove={approveProvider} onReject={rejectProvider} onToggle={toggleProvider} />}
        {activeTab === 'patients' && <PatientsTab patients={patients} />}
      </div>
    </div>
  );
}

// ═══ ENTRY ═══
export default function AdminPortal({ onLogout }) {
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const root = document.getElementById('root');
    const prevBody = document.body.getAttribute('style') || '';
    const prevHtml = document.documentElement.getAttribute('style') || '';
    document.body.style.cssText = 'margin:0;padding:0;width:100vw;height:100vh;background:#f8fafc;overflow:hidden;max-width:none;';
    document.documentElement.style.cssText = 'margin:0;padding:0;width:100vw;height:100vh;';
    if (root) root.style.cssText = 'width:100vw;height:100vh;margin:0;padding:0;max-width:none;';
    return () => {
      document.body.setAttribute('style', prevBody);
      document.documentElement.setAttribute('style', prevHtml);
      if (root) root.style.cssText = '';
    };
  }, []);

  if (!admin) return <AdminLogin onLogin={setAdmin} />;
  return <AdminApp onLogout={() => { setAdmin(null); onLogout(); }} />;
}